<ds-modal
  [id]="gracePeriodModal"
  [closeOthers]="true"
  [maxWidth]="modalWidth"
  (onCloseModalEvent)="close()"
  (initialized)="modalInitialized($event)"
>
  @if (!isPartner) {
    <h2 class="neutral-600-text pad-left-20">
      <b class="block">Looking to add or replace a vehicle?</b>
    </h2>
  }
  @if (isPartner) {
    <h2 class="neutral-600-text pad-left-20">
      <b class="block">Looking to add a new vehicle?</b>
    </h2>
  }
  <div class="row pad-20">
    <div class="column twelve">
      <p>
        <!--
        TODO - Move these strings to the copy service and the days to a variable in the component
        -->
        Your policy includes coverage for <span>{{ gracePeriodDays }}</span> days from the date of
        purchase. The new vehicle just needs to meet a few eligibility requirements:
      </p>
      <ul class="margin-top-20 bullet -superCondensed">
        <li>Personal vehicle (car, truck, SUV)</li>
        <li>
          Not over our weight restrictions
          @if (isPartner) {
            <span>: gross vehicle weight of 0-15,000 lbs.</span>
          }
        </li>
        <li>Not for business use</li>
        <li>Not for commercial delivery or transport</li>
      </ul>
      <p>
        Other eligibility rules could apply based on your policy. You’ll need to notify us within
        <span> {{ gracePeriodDays }} </span> days of the purchase and pay any additional premium
        that applies. If you have questions, feel free to contact
        @if (!isPartner) {
          <span>your agent</span>
        }
        @if (isPartner) {
          <span>an advisor</span>
        }
        to discuss coverage options.
      </p>
    </div>
  </div>
</ds-modal>
